import { render, staticRenderFns } from "./PurchasePlace.vue?vue&type=template&id=39e145b6&"
import script from "./PurchasePlace.vue?vue&type=script&lang=js&"
export * from "./PurchasePlace.vue?vue&type=script&lang=js&"
import style0 from "./PurchasePlace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports